import script from "./upload-cv.vue?vue&type=script&setup=true&lang=js"
export * from "./upload-cv.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__